/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserLeaveOrganisationRequest, UserLeaveOrganisationResponse } from '../types/UserLeaveOrganisation'

/**
 * POST /users/leave-organisation
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::leaveOrganisation
 */
export async function userLeaveOrganisation(
	data: UserLeaveOrganisationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserLeaveOrganisationResponse>> {
	return axiosInstance.post('/users/leave-organisation', data, config)
}
